import React from 'react';
import PropTypes from 'prop-types';
import { session_penalties_url } from './teacher_payments_link';
import './payment_penalties.css';

const LINK_STYLE = {
  color: 'var(--text-link-brand)',
  fontWeight: 600,
  textDecoration: 'underline'
};

// Session page entry points: this class in Teacher Payments, and (with on_view_here) its penalties pop-up.
export default function TeacherPaymentsLink({ teacher_uuid, epoch_start_time, on_view_here }) {
  return (
    <p className="tp-sp-links">
      <a
        style={LINK_STYLE}
        href={session_penalties_url({ teacher_uuid, epoch_start_time })}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="view-in-teacher-payments"
      >
        View in Teacher Payments
      </a>
      {on_view_here ? (
        <button
          type="button"
          className="tp-sp-here"
          onClick={on_view_here}
          aria-haspopup="dialog"
          data-testid="view-penalties-here"
        >
          View penalties here
        </button>
      ) : null}
    </p>
  );
}

TeacherPaymentsLink.propTypes = {
  teacher_uuid: PropTypes.string,
  epoch_start_time: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  on_view_here: PropTypes.func
};

TeacherPaymentsLink.defaultProps = { teacher_uuid: '', epoch_start_time: 0, on_view_here: null };
